import React from 'react';
import { connect } from 'react-redux';
import { Button, Typography, Modal } from 'antd';

import { forgotPasswordRequest } from '../../AuthenticationApiActions';
import CustomIcon from '../../../../utils/components/CustomIcon/CustomIcon'
import Notification from '../../../../utils/Notification';

import './ResetPassword.css';

const notification = new Notification()

const ResetPasswordComponent = (props) => {
  const { visible, onCancel, user } = props

  const resetPassword = () => {
    props.forgotPassword({ email: user.email }).then(() => {
      notification.show('info', 'Reset User Password', 'Temporary password is sent to the registered email address');
      onCancel()
    });
  };

  return (<Modal
    open={visible}
    title={
      <div className="flex-horizontal-gap-4">
        <CustomIcon name="LockClosed" width={40} height={40} />
        <Typography.Title level={2} style={{ margin: 0 }}>Reset User Password</Typography.Title>
      </div>
    }
    onCancel={onCancel}
    footer={null}
    width={800}
    bodyStyle={{
      maxHeight: '70vh',
      overflowY: 'auto'
    }}
  >
    <div className="flex-vertical-gap-4">
      <div>The user will receive an email with a temporary password on a registered email address.</div>
      <Button block type="primary" onClick={resetPassword}>
        Reset User Password
        <CustomIcon name="Reset" />
      </Button>
      <Button block onClick={onCancel}>
        Cancel
        <CustomIcon name="CloseX" />
      </Button>
    </div>
  </Modal>)
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    forgotPassword: (data) => {
      return dispatch(forgotPasswordRequest(data)).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    }
  }
};

const ResetPassword = connect(
  null,
  mapDispatchToProps
)(ResetPasswordComponent);

export default ResetPassword;
